import { Checkbox, FormControl, FormControlLabel, FormHelperText, Grid, InputLabel, ListItemText, MenuItem, OutlinedInput, Select, Slider, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from "@mui/material";
import { useEffect } from "react";

const GlobalExpertiseStep = ({ props }) => {
    useEffect(() => {
        if (props.isEdit) {
            props.handleLanguagesSelectChange(Object.keys(props.proficiency));
        }
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [])

    return (
        <Grid container spacing={2}>
            <Grid item xs={12} sm={12}>
                <Typography variant="h5" sx={{ marginTop: '3rem' }} gutterBottom>
                    Language proficiency (multiple answers possible):
                </Typography>
                <Grid item xs={12} container >
                    <Grid item>
                        {props.emptyFormProps.includes('language_proficiency') && <FormHelperText><b style={{ color: '#d32f2f' }}>This field is required</b></FormHelperText>}
                    </Grid>
                </Grid>
                <Grid item xs={12}>

                    <FormControl fullWidth size="small">
                        <InputLabel id="specialty-select-label">Language proficiency</InputLabel>
                        <Select
                            labelId="specialty-select-label"
                            multiple
                            value={props.selectedLanguages}
                            onChange={e => props.handleLanguagesSelectChange(e.target.value)}
                            input={<OutlinedInput label="Specialties" />}
                            renderValue={(selected) =>
                                props.languages
                                    .filter(field => props.isEdit ? selected.includes(field.value) : selected.includes(field.id))
                                    .map(field => field.value)
                                    .join(', ')
                            }
                        >
                            {props.languages
                                .map((field) => (
                                    <MenuItem key={field.id} value={field.id}>
                                        <Checkbox checked={props.isEdit ? (props.selectedLanguages.includes(field.value) || props.selectedLanguages.includes(field.id)) : props.selectedLanguages.includes(field.id)} />
                                        <ListItemText primary={field.value} />
                                    </MenuItem>
                                ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Table>
                    <TableBody>
                        {props.languages.filter(x => props.isEdit ? (props.selectedLanguages.includes(x.value) || props.selectedLanguages.includes(x.id)) : props.selectedLanguages.includes(x.id)).map(lang => (lang.value !== 'Other') && (
                            <TableRow key={lang.id} sx={{ borderBottom: '2px solid', borderColor: 'primary.main' }}>
                                <TableCell>{lang.value}</TableCell>
                                <TableCell>
                                    <TextField name="wtf" style={{ visibility: 'hidden' }} variant="outlined" size="small" />
                                    <Slider
                                        value={props.proficiency[lang.value]}
                                        onChange={props.handleSliderChange(lang.value)}
                                        step={1}
                                        marks={props.languageMarks}
                                        min={1}
                                        max={4}
                                        valueLabelDisplay="auto"
                                    />
                                </TableCell>
                            </TableRow>
                        ))}

                        {props.selectedLanguages.includes(0) && (
                            <TableRow sx={{ borderBottom: '2px solid', borderColor: 'primary.main' }}>
                                <TableCell>Other (please specify):</TableCell>
                                <TableCell>
                                    <TextField name="language_proficiency_other" value={props.isEdit ? props.formData.language_proficiency_other.split(' - ')[0] : props.formData.language_proficiency_other} onChange={e => props.handleInputChange(e)} variant="outlined" size="small" />
                                    <Slider
                                        value={props.proficiency.Other}
                                        onChange={props.handleSliderChange('Other')}
                                        step={1}
                                        marks={props.languageMarks}
                                        min={0}
                                        max={4}
                                        valueLabelDisplay="auto"
                                    />
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </Grid>
            <Grid item xs={12}>
                <Typography variant="h5" sx={{ marginTop: '3rem' }} gutterBottom>
                    Specific regional experience (multiple answers possible):
                </Typography>
                <Typography variant="body1">
                    Please state in which geographic regions/countries you have expertise:
                </Typography>
                <Grid item xs={12} container >
                    <Grid item>
                        {props.emptyFormProps.includes('regional_experience') && <FormHelperText><b style={{ color: '#d32f2f' }}>This field is required</b></FormHelperText>}
                    </Grid>
                </Grid>
                <Table>
                    <TableHead sx={{ borderBottom: '2px solid', borderColor: 'primary.main' }}>
                        <TableCell>
                            <strong>
                                WHO Regions
                            </strong>
                        </TableCell>
                        <TableCell>
                            <strong>
                                Years of experience
                            </strong>
                        </TableCell>
                    </TableHead>
                    <TableBody>
                        {props.regionalExperience.map(field => (
                            <TableRow sx={{ borderBottom: '2px solid', borderColor: 'primary.main' }}>
                                <TableCell>{field.value}</TableCell>
                                <TableCell>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={props.formData.regional_experience.some(x => x.value === field.value && x.years_of_experience === "<5")}
                                                onChange={() => props.handleRegionalExperienceChange(field, "<5")}
                                            />
                                        }
                                        label="<5"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={props.formData.regional_experience.some(x => x.value === field.value && x.years_of_experience === "5-10")}
                                                onChange={() => props.handleRegionalExperienceChange(field, "5-10")}
                                            />
                                        }
                                        label="5-10"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={props.formData.regional_experience.some(x => x.value === field.value && x.years_of_experience === ">10")}
                                                onChange={() => props.handleRegionalExperienceChange(field, ">10")}
                                            />
                                        }
                                        label=">10"
                                    />
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Grid>
            <Grid item xs={12} sm={12}>
                <FormControl fullWidth size="small">
                    <InputLabel id="supprot-select-label">Select countries from the regions(s) you selected</InputLabel>
                    <Select
                        labelId="support-select-label"
                        multiple
                        name="regional_experience_countries"
                        value={props.formData.regional_experience_countries}
                        onChange={props.handleRegionalExperienceCountryChange}
                        input={<OutlinedInput label="Countries" />}
                        renderValue={(x) =>
                            props.formData.regional_experience_countries
                                .filter(y => x.includes(y))
                                .map(el => el)
                                .join(', ')
                        }
                    >
                        {props.countryOptionsRegions.map((option) => (
                            <MenuItem sx={{ '& > img': { mr: 2, flexShrink: 0 } }} key={option.value} value={option.value}>
                                <img
                                    loading="lazy"
                                    width="20"
                                    srcSet={option.flag}
                                    src={option.flag}
                                    alt=""
                                />
                                <ListItemText primary={option.label} />
                                <Checkbox checked={props.formData.regional_experience_countries.includes(option.label)} />
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
        </Grid>
    );
}

export default GlobalExpertiseStep;